import { H2, Paragraph, Svg, Wrapper } from '@thisisdevelopment/akzonobel-core';
import { useState } from 'react';
import { Details, DownloadDescriptions, Summary, ToggleButton } from './styled';

interface DocumentDownloadListProps {
  product: any;
  title: string;
  maxLength?: number;
}

export const DocumentDownloadList = ({
  product,
  title,
  maxLength = 3,
}: DocumentDownloadListProps) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  if (product.documents.length <= 0) {
    return null;
  }

  return (
    <Wrapper>
      <DownloadDescriptions>
        <Wrapper>
          <H2>{title}</H2>
          {product.hse && (
            <Paragraph className="downloadTitle">{product.hse}</Paragraph>
          )}
          <Paragraph
            onClick={() =>
              window.open(
                'https://get.adobe.com/reader/otherversions/',
                '_blank'
              )
            }
            className="downloadType"
          >
            Download Adobe Reader
          </Paragraph>
        </Wrapper>
        {product.documents.length <= maxLength ? (
          product.documents
            .filter((_: DocumentProps, i: number) => i < maxLength)
            .map((document: DocumentProps, i: number) => (
              <Document key={i} document={document} />
            ))
        ) : (
          <>
            <Details open={detailsOpen}>
              <Summary>
                {product.documents
                  .filter((_: DocumentProps, i: number) => i < maxLength)
                  .map((document: DocumentProps, i: number) => (
                    <Document key={i} document={document} />
                  ))}
              </Summary>
              <span>
                {product.documents
                  .filter((_: DocumentProps, i: number) => i >= maxLength)
                  .map((document: DocumentProps, i: number) => (
                    <Document key={i} document={document} />
                  ))}
              </span>
            </Details>{' '}
            <ToggleButton onClick={() => setDetailsOpen((prev) => !prev)}>
              {detailsOpen
                ? `Hide ▲`
                : `Show all (${product.documents.length}) ▼`}
            </ToggleButton>
          </>
        )}
      </DownloadDescriptions>
    </Wrapper>
  );
};

interface DocumentProps {
  description: string;
  title: string;
  type: string;
  url: string;
}

const Document = ({ document }: { document: DocumentProps }) => {
  const { description, title, url } = document;
  return (
    <Wrapper className="downloadWrapper">
      <Svg.Pdf className="pdfLogo" />
      {description && <Paragraph className="fileName">{description}</Paragraph>}
      {!description && <Paragraph className="fileName">{title}</Paragraph>}
      <Svg.Download
        onClick={() => window.open(url, '_blank')}
        className="downloadLogo"
      ></Svg.Download>
    </Wrapper>
  );
};
